/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as TYPES from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setTaskType = (payload) => {
  return {
    type: TYPES.SET_TASK_TYPE,
    payload,
  };
};
export const setPlanType = (payload) => {
  return {
    type: TYPES.SET_PLAN_TYPE,
    payload,
  };
};
export const setRebateProgram = (payload) => {
  return {
    type: TYPES.SET_REBATE_PROGRAM,
    payload,
  };
};
// export const sysReminderSetupList = (data) => {
//   return {
//     type: TYPES.SET_REMINDER_SETUP_LIST,
//     reminderSetupList: data,
//   };
// };
export const sysReminderSetupList = (data) => ({
  type: TYPES.SET_REMINDER_SETUP_LIST,
  reminderSetupList: data,
});
export const dispatchTemplateType = (data) => ({
  type: TYPES.GET_ALL_TEMPLATE_TYPE,
  TemplateType: data,
});
// dispatch pagination input value
export const dispatchInputValue = (data) => ({
  type: TYPES.INPUT_FIELD_VALUE_ACTION,
  payloadInputVal: data,
});
// checklog error msg dispatch function
export const dispatchCheckLogErrorMsg = (data) => ({
  type: TYPES.GET_CHECKLOG_ERROR_MSG,
  payload: data,
});
// Days since Check Suspension error msg dispatch function
export const dispatchCheckSuspErrorMsg = (data) => ({
  type: TYPES.GET_CHECKSUSP_ERROR_MSG,
  payload: data,
});
// collection letter error msg dispatch function
export const dispatchCollectErrorMsg = (data) => ({
  type: TYPES.GET_COLLECT_ERROR_MSG,
  payload: data,
});
// Mailed Date error msg dispatch function
export const dispatchMailedDateErrorMsg = (data) => ({
  type: TYPES.GET_MAILED_DATE_ERROR_MSG,
  payload: data,
});
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: TYPES.SAVE_OR_UPDATE_RR,
  };
};
export const dispatchDeleteReminder = (data) => {
  return {
    getDeleteReminder: data,
    type: TYPES.DELETE_REMINDER,
  };
};

export const getSysReminderSetup = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_REMINDER_SETUP_LIST}`, val)
    .then((response) => {
      const newObj = response?.data?.sysReminderResponse?.map((item) => {
        item.addEditRow = false;
        return item;
      });
      dispatch(sysReminderSetupList(newObj));
    })
    .catch(() => {
      dispatch(sysReminderSetupList([]));
    });
};
// eslint-disable-next-line consistent-return
export const postSaveOrUpdate = (value, saveType) => (dispatch) => {
  return axios
    .post(serviceEndPoint.ADD_UPDATE_SYSTEM_REMINDER, value)
    .then((response) => {
      if (saveType) {
        dispatch(dispatchSaveOrUpdate('closeTab'));
      } else {
        dispatch(dispatchSaveOrUpdate(response.data));
      }
    })
    .catch(() => {
      dispatch(dispatchSaveOrUpdate('failed'));
    });
};
export const getAllTemplateType = (values) => (dispatch) => {
  if (values?.rebateProgramCd) {
    return axios
      .post(serviceEndPoint.GET_ALL_TEMPLATE_TYPE, values)
      .then((response) => {
        return dispatch(dispatchTemplateType(response.data));
      })
      .catch(() => {
        dispatch(dispatchTemplateType([]));
      });
  }
  return [];
};
export const getRebateProgramCodePRT = (values) => async (dispatch) => {
  if (values) {
    try {
      const response = await axios.post(
        `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
        { planType: values }
      );
      if (response?.data?.data?.length > 0) {
        const newData = [];
        response.data.data.forEach((item) => {
          newData.push({
            label: `${item.rebateProgramCd} | ${item.shortDescr}`,
            value: item.rebateProgramCd,
            ...item,
          });
        });
        dispatch({ type: TYPES.SET_REBATE_LIST, payload: newData });
      } else {
        dispatch({ type: TYPES.SET_REBATE_LIST, payload: [] });
      }
    } catch (e) {
      dispatch({ type: TYPES.SET_REBATE_LIST, payload: [] });
    }
  }
};
